__webpack_require__.p = "/reports-milestone-4-translations/referrals-hub/";